import React, { useState } from 'react';
import './style.scss';

function FinancialCalendarItem({ item }) {
    const [isSelected, setIsSelected] = useState(false);

    const downloadCalendar = () => {
        setIsSelected(!isSelected);
    };

    return (
        <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`financial-calendar-item ${isSelected ? 'selected' : ''}`}
            onClick={downloadCalendar}
        >
            <h1 className="title">{item.text}</h1>
            <p className="description">
                {item.description}
                {item.subline ? <div className="subline">{item.subline}</div> : null}
            </p>
            <h1 className="add-to">+ Add to calendar</h1>
        </a>
    );
}

export default FinancialCalendarItem;
